import Vue from "vue";
import Router from "vue-router";
import store from "./store/index";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: resolve => require(["./views/home/index.vue"], resolve)
    },
    {
      path: "/about_us",
      name: "about_us",
      component: () => import("./views/about.vue")
    },
    {
      path: "/contact_us",
      name: "contact_us",
      component: () => import("./views/contact.vue")
    },
    {
      path: "/parse",
      name: "parse",
      component: () => import("./views/parse.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/account/login.vue")
    },
    {
      path: "/user/register",
      name: "user_register",
      component: () => import("./views/account/register.vue")
    },
    {
      path: "/goods/list",
      name: "goods_list",
      component: () => import("./views/goods/list.vue")
    },
    {
      path: "/goods/collect",
      name: "parse",
      component: () => import("./views/goods/collect.vue")
    },
    {
      path: "/goods/seckill",
      name: "goods_seckill",
      component: () => import("./views/goods/seckill.vue")
    },
    {
      path: "/goods/info/:goods_id",
      name: "home_goods_info",
      component: () => import("./views/goods/info.vue")
    },
    {
      path: "/goods/cart",
      name: "goods_cart",
      meta: { requireAuth: true },
      component: () => import("./views/goods/cart.vue")
    },
    {
      path: "/user/index",
      name: "user_index",
      component: () => import("./views/user/index.vue"),
      children: [
        {
          path: "",
          name: "user_order",
          meta: {
            hideNav: true,
            requireAuth: true
          },
          component: () => import("./views/user/order.vue")
        },
        {
          path: "/user/info",
          name: "user_info",
          meta: {
            hideNav: true,
            requireAuth: true
          },
          component: () => import("./views/user/info.vue")
        },
        {
          path: "/user/coupon",
          name: "user_coupon",
          meta: {
            hideNav: true,
            requireAuth: true
          },
          component: () => import("./views/user/coupon.vue")
        },
        {
          path: "/user/card",
          name: "user_card",
          meta: {
            hideNav: true,
            requireAuth: true
          },
          component: () => import("./views/user/card.vue")
        },
        {
          path: "/user/user_info",
          name: "home_user_info",
          meta: {
            requireAuth: true
          },
          component: () => import("./views/user/info.vue")
        },
        {
          path: "/user/record",
          name: "user_record",
          meta: {
            hideNav: true,
            requireAuth: true
          },
          component: () => import("./views/user/record.vue")
        },
        {
          path: "/user/rule",
          name: "user_rule",
          meta: {
            hideNav: true,
            requireAuth: true
          },
          component: () => import("./views/user/rule.vue")
        }
      ]
    },
    {
      path: "/order/confirm",
      name: "order_confirm",
      component: () => import("./views/order/confirm.vue"),
      meta: {
        hideNav: true,
        requireAuth: true
      }
    },
    {
      path: "/order/detail",
      name: "order_detail",
      component: () => import("./views/order/detail.vue"),
      meta: {
        hideNav: true,
        requireAuth: true
      }
    },
    {
      path: "/home/machine",
      name: "home_machine",
      component: resolve => require(["./views/home/machine.vue"], resolve)
    },
    {
      path: "/home/coffee",
      name: "home_coffee",
      component: resolve => require(["./views/home/coffee.vue"], resolve)
    },
    {
      path: "/machine/index",
      name: "machine_index",
      component: () => import("./views/machine/index.vue")
    },
    {
      path: "/coffee/index",
      name: "coffee_index",
      component: () => import("./views/coffee/index.vue")
    },
    {
      path: "/forget",
      name: "account_forget",
      component: () => import("./views/account/forget.vue")
    },
    {
      path: "/register",
      name: "account_register",
      component: () => import("./views/account/register.vue")
    },
    {
      path: "/help",
      name: "help",
      component: () => import("./views/home/help.vue")
    },
    {
      path: "/points/index",
      name: "points",
      component: () => import("./views/points/index.vue")
    },
    {
      path: "/points/detail",
      name: "points_detail",
      component: () => import("./views/points/detail.vue")
    },
    {
      path: "/card/list",
      name: "card_list",
      component: resolve => require(["./views/card/list.vue"], resolve)
    },
    {
      path: "/card/info/:card_id",
      name: "card_info",
      component: () => import("./views/card/info.vue")
    }
  ]
});
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

router.beforeEach(async (to, from, next) => {
  // if (!store.state.user.isLogin) {
  //     localStorage.clear()
  // }
  if (store.state.user.isLogin && !store.state.user.phone) {
    // 更新用户信息
    store.dispatch("updateUserInfo");
  }
  if (!store.state.user.config) {
    // 更新配置信息
    store.dispatch("getSysConfig");
  }
  if (!store.state.user.location) {
    // 获取定位信息
    await store.dispatch("getLocation");
  }
  if (to.meta.requireAuth) {
    // 判斷該路由是否需要登錄權限
    if (store.state.user.isLogin) {
      // 通過vuex state獲取當前的token是否存在
      next();
    } else {
      next({
        path: "/login"
      });
    }
  } else {
    next();
  }
});
export default router;
